// src/presets/lara/speeddial/index.ts
var speeddial_default = {
  root: {
    gap: "0.5rem",
    transitionDuration: "{transition.duration}"
  }
};
export { speeddial_default as default };
